import keyMirror from 'keymirror';

const GradientTypes = keyMirror({
    SOLID: null,
    HORIZONTAL: null,
    VERTICAL: null,
    RADIAL: null
});
export default GradientTypes;
